module.exports = __webpack_public_path__ + "media/images/share-bd72e07eb79590bd80a7c867781c9106.svg";